/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-46de7b2e.js';
import { _ as _slicedToArray } from '../../_chunks/dep-e43cf21c.js';
import React from 'react';
import classNames from 'classnames';
import { useLocaleReceiver } from '../../locale/LocalReceiver.js';
import useConfig from '../../hooks/useConfig.js';
import DatePickerCell from './Cell.js';
import { parseToDayjs } from '../../_common/js/date-picker/format.js';
import '../../_chunks/dep-2acfafca.js';
import '../../config-provider/index.js';
import '../../config-provider/ConfigProvider.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-d71ee5f3.js';
import '../../_chunks/dep-4b8f240e.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-934eda0c.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-6b568d83.js';
import '../../_chunks/dep-304e657b.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-6506fbc2.js';
import '../../_chunks/dep-bb5d7b1e.js';
import '../../_chunks/dep-e285f2f8.js';
import '../../_chunks/dep-f4a320cd.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../config-provider/ConfigContext.js';
import '../../locale/zh_CN.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../../_chunks/dep-cbcc9f89.js';
import '../../_common/js/global-config/default-config.js';
import '../../_common/js/date-picker/utils.js';
import '../../_chunks/dep-fdce1f4f.js';
import '../../_chunks/dep-77a54538.js';
import '../../_chunks/dep-c1f93350.js';
import '../../_chunks/dep-c00532d4.js';
import '../../_chunks/dep-6c5254c6.js';
import '../../_common/js/log/index.js';
import '../../_common/js/log/log.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DatePickerTable = function DatePickerTable(props) {
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var value = props.value,
    format = props.format,
    mode = props.mode,
    data = props.data,
    time = props.time,
    onCellClick = props.onCellClick,
    onCellMouseEnter = props.onCellMouseEnter,
    onCellMouseLeave = props.onCellMouseLeave,
    firstDayOfWeek = props.firstDayOfWeek;
  var _useLocaleReceiver = useLocaleReceiver("datePicker"),
    _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 2),
    local = _useLocaleReceiver2[0],
    t = _useLocaleReceiver2[1];
  var weekdays = t(local.weekdays);
  var weekAbbreviation = t(local.weekAbbreviation);
  var weekArr = [];
  var wi = firstDayOfWeek - 1;
  var len = weekdays.length;
  while (weekArr.length < len) {
    weekArr.push(weekdays[wi]);
    wi = (wi + len + 1) % len;
  }
  if (mode === "week") weekArr.unshift(weekAbbreviation);
  var showThead = mode === "date" || mode === "week";
  var weekRowClass = function weekRowClass(value2, format2, targetValue) {
    if (mode !== "week" || !value2) return {};
    if (Array.isArray(value2)) {
      var _startObj$year, _startObj$locale, _startObj$locale$call, _startObj$locale$call2, _endObj$year, _endObj$locale, _endObj$locale$call, _endObj$locale$call$w, _ref;
      if (!value2.length) return {};
      var _value2$map = value2.map(function (v) {
          return v && parseToDayjs(v, format2);
        }),
        _value2$map2 = _slicedToArray(_value2$map, 2),
        startObj = _value2$map2[0],
        endObj = _value2$map2[1];
      var startYear = startObj === null || startObj === void 0 ? void 0 : (_startObj$year = startObj.year) === null || _startObj$year === void 0 ? void 0 : _startObj$year.call(startObj);
      var startWeek = startObj === null || startObj === void 0 ? void 0 : (_startObj$locale = startObj.locale) === null || _startObj$locale === void 0 ? void 0 : (_startObj$locale$call = _startObj$locale.call(startObj, local.dayjsLocale)) === null || _startObj$locale$call === void 0 ? void 0 : (_startObj$locale$call2 = _startObj$locale$call.week) === null || _startObj$locale$call2 === void 0 ? void 0 : _startObj$locale$call2.call(_startObj$locale$call);
      var endYear = endObj === null || endObj === void 0 ? void 0 : (_endObj$year = endObj.year) === null || _endObj$year === void 0 ? void 0 : _endObj$year.call(endObj);
      var endWeek = endObj === null || endObj === void 0 ? void 0 : (_endObj$locale = endObj.locale) === null || _endObj$locale === void 0 ? void 0 : (_endObj$locale$call = _endObj$locale.call(endObj, local.dayjsLocale)) === null || _endObj$locale$call === void 0 ? void 0 : (_endObj$locale$call$w = _endObj$locale$call.week) === null || _endObj$locale$call$w === void 0 ? void 0 : _endObj$locale$call$w.call(_endObj$locale$call);
      var targetObj = parseToDayjs(targetValue, format2);
      var targetYear = targetObj.year();
      var targetWeek = targetObj.week();
      var isActive = targetYear === startYear && targetWeek === startWeek || targetYear === endYear && targetWeek === endWeek;
      var isRange = targetYear >= startYear && targetYear <= endYear && targetWeek > startWeek && targetWeek < endWeek;
      return _ref = {}, _defineProperty(_ref, "".concat(classPrefix, "-date-picker__table-").concat(mode, "-row--active"), isActive), _defineProperty(_ref, "".concat(classPrefix, "-date-picker__table-").concat(mode, "-row--range"), isRange), _ref;
    }
    return _defineProperty({}, "".concat(classPrefix, "-date-picker__table-").concat(mode, "-row--active"), parseToDayjs(value2, format2).locale(local.dayjsLocale).week() === parseToDayjs(targetValue, format2).locale(local.dayjsLocale).week());
  };
  return /* @__PURE__ */React.createElement("div", {
    className: "".concat(classPrefix, "-date-picker__table"),
    onMouseLeave: function onMouseLeave(e) {
      return onCellMouseLeave === null || onCellMouseLeave === void 0 ? void 0 : onCellMouseLeave({
        e: e
      });
    }
  }, /* @__PURE__ */React.createElement("table", null, showThead && /* @__PURE__ */React.createElement("thead", null, /* @__PURE__ */React.createElement("tr", null, weekArr.map(function (value2, i) {
    return /* @__PURE__ */React.createElement("th", {
      key: i
    }, value2);
  }))), /* @__PURE__ */React.createElement("tbody", null, data.map(function (row, i) {
    return /* @__PURE__ */React.createElement("tr", {
      key: i,
      className: classNames("".concat(classPrefix, "-date-picker__table-").concat(mode, "-row"), _objectSpread({}, weekRowClass(value, format, row[0].value)))
    }, row.map(function (col, j) {
      return /* @__PURE__ */React.createElement(DatePickerCell, _objectSpread(_objectSpread({}, col), {}, {
        key: j,
        time: time,
        onClick: onCellClick,
        onMouseEnter: onCellMouseEnter
      }));
    }));
  }))));
};
DatePickerTable.displayName = "DatePickerTable";

export { DatePickerTable as default };
//# sourceMappingURL=Table.js.map
